import { useHookstate } from "@hookstate/core"
import { getDateOnly, onInputChangeNative } from "../../../misc/utils";
import InputField from "../../../components/input-field/InputField";
import DefaultButton from "../../../components/default-button/DefaultButton";
import Plus from "../../../assets/icons/Plus";
import Modal from "../../../components/Modal/Modal";
import { ExamCreate } from "./ExamCreate";
import { useNewUniversalFind } from "../../../hooks/universal";
import { examTableColumns } from "../../../misc/constants";
import { Exam } from "../../../types";
import CalendarTime from "../../../assets/icons/CalendarTime";
import { simpleGetter } from "../../../actions/common";
import { CARTERA_API_HOST, examApi } from "../../../api/api";
import { accessGlobalUserState } from "../../../stores/user";

type ExamsState = {
    search: string;
    modalOpen: boolean;
    triggerFetch: number;
}

export const Exams = () => {
    const userState = accessGlobalUserState().get()
    const localState = useHookstate<ExamsState>({
        search: '',
        modalOpen: false,
        triggerFetch: 0
    })
    const state = localState.get()
    const { modalOpen, search, triggerFetch } = state

    const toggleModal = (trigger = false) => () => {
        if (trigger) {
            localState.triggerFetch.set(triggerFetch + 1)
        }
        localState.modalOpen.set(!modalOpen)
    }

    const exams: Exam[] = useNewUniversalFind('Exam', {}, undefined, {
        include: ['course', 'classes']
    }, triggerFetch)

    const renderStatus = (status: number) => {
        const meta = {
            Icon: CalendarTime,
            label: 'Запланирован'
        }

        const Icon = meta.Icon

        return (
            <div className="flex flex-row items-center gap-1.5">
                <Icon />
                <span className="font-bold text-[15px] text-valley-gray leading-[130%]">
                    {meta.label}
                </span>
            </div>
        )
    }

    const downloadQr = (id: number) => async () => {
        const response = await fetch(`${CARTERA_API_HOST}/api/v1/exams/${id}/codes`, {
            headers: {
                Authorization: `Bearer ${userState.uniqToken}`
            }
        })
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'exam.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    return (
        <div className="flex flex-col h-full p-8 overflow-y-auto">
            <div className="flex flex-col flex-1 gap-4 p-4 bg-white rounded-xl">
                <div className="flex flex-row gap-8 justify-between">
                    <InputField
                        wrapperClassName="flex-1"
                        additionalClassName="rounded-lg py-3 px-4 bg-valley-background-blue"
                        value={search}
                        handleChange={onInputChangeNative(localState, 'search')}
                        type="text"
                        placeholder="Поиск"
                    />
                    <DefaultButton
                        additionalStyle="border-valley-dark-green text-valley-dark-green py-[9px] px-6"
                        Icon={Plus}
                        buttonText="Создать экзамен"
                        onClick={toggleModal()}
                    />
                </div>
                <div className="flex flex-col flex-1 overflow-y-auto">
                    <table className="table-auto lesson-students-table">
                        <thead>
                            <tr className="text-valley-black">
                                {examTableColumns.map(c => (
                                    <td>
                                        <span>{c}</span>
                                    </td>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="text-valley-black">
                            {exams.map((e, i) => (
                                <tr>
                                    <td>
                                        <span>
                                            {i + 1}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {e.name}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {e.course?.name}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="flex flex-row gap-2">
                                            {e.classes?.map(cl => (
                                                <div className="flex flex-row items-center p-2 rounded-xl gap-2 bg-[#0068FF1F]">
                                                    <span className="text-[13px] leading-[130%] text-valley-black">
                                                        {cl.name}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-0.5">
                                            <span className="font-semibold text-[13px] leading-[120%] text-valley-black">
                                                {getDateOnly(e.start_date)}
                                            </span>
                                            <span className="text-[13px] leading-[120%] text-valley-gray">
                                                {e.start_time}-{e.end_time}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        {renderStatus(e.status)}
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-2">
                                            <DefaultButton
                                                additionalStyle="rounded-lg border border-valley-gray text-valley-gray py-1 px-3"
                                                buttonText="Скачать QR-коды"
                                                onClick={downloadQr(e.id)}
                                            />
                                            <DefaultButton
                                                additionalStyle="rounded-lg border border-valley-main text-valley-main py-1 px-3"
                                                buttonText="Результаты"
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal
                additionalClassName="w-[32.5%] rounded-xl flex flex-col p-0"
                visible={modalOpen}
                setVisible={toggleModal}
            >
                <ExamCreate toggleModal={toggleModal} />
            </Modal>
        </div>
    )
}